<template>
  <ReviewStep
    :title="props.profitInfo.profit.value"
    head="Revise os dados da sua assinatura"
    subtitle="Total"
    @back="$emit('back')"
  >
    <ContentDisplay
      footer-type="caption"
      :blocks-length="2"
      :footer-label="props.profitInfo.terms.observation"
    >
      <template #content-block-1>
        <HeadingDisplay
          :title="props.profitInfo.profit.title"
          size="extra-small"
        />
        <ListDisplay title="Renovação" value="Mensal" />
        <ListDisplay title="Data de solicitação" :value="getLocalDate()" />
      </template>
    </ContentDisplay>
    <template #button-container>
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary
            label="Continuar"
            :loading="props.isLoading"
            @click="$emit('click')"
          />
        </template>
      </ButtonContainer>
    </template>
  </ReviewStep>
</template>

<script setup lang="ts">
import {
  ReviewStep,
  ContentDisplay,
  ListDisplay,
  HeadingDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { ProfitPreview } from '@/modules/trade/services/profit';

interface Props {
  profitInfo: ProfitPreview;
  isLoading: boolean;
}

interface EmitEvents {
  (event: 'click'): void;
  (event: 'back'): void;
}

defineEmits<EmitEvents>();

const props = defineProps<Props>();

function getLocalDate() {
  return new Date().toLocaleDateString();
}
</script>
